module.exports = __webpack_public_path__ + "home-03.png?1084557cbc9736aea35cf23744af57c5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wap/home-03.png
// module id = 174
// module chunks = 0